import React, { useCallback, useRef, useState } from 'react';
import { Table } from '@devexpress/dx-react-grid-material-ui';
import { useDispatch } from "react-redux";
import { Button, Menu, MenuItem } from '@mui/material';
import { actions } from '../PatientView.redux';
import DeletePopover from 'components/DeletePopover';
import { useNavigate, useParams } from '@tanstack/react-router';



const PatientReportsCell = (props) => {
	const { column, row } = props;
	const { patient_id } = useParams({ from: '/patients/view/$patient_id' });
	const id                              = row.urpt_id,
		  dispatch                        = useDispatch(),
		  navigate                        = useNavigate(),
		  actionAnchor                    = useRef(null),
		  [ actionsOpen, setActionsOpen ] = useState(false);


	const beforeDeleteReport = useCallback(() => {
		dispatch(actions.setState({
			loading: true,
		}));
	}, [ dispatch ]);

	const afterDeleteReport = useCallback(() => {
		dispatch(actions.loadReports(patient_id));
		setActionsOpen(false);
	}, [ dispatch ]);


	const handleNavigate = useCallback(() => {
		navigate({ to: `/reports/edit/${id}` });
	}, [ navigate, id ]);



	if(column.name === 'actions') {
		return (
			<Table.Cell
				{...props}
			>
				<Button
					variant="outlined"
					size="large"
					onClick={() => setActionsOpen(true)}
					ref={actionAnchor}
				>
					...
				</Button>
				<Menu

					open={actionsOpen}
					onClose={() => setActionsOpen(false)}
					anchorEl={actionAnchor.current}
				>
					<MenuItem>
						<DeletePopover
							objectType="REPORT"
							objectID={id}
							afterDelete={afterDeleteReport}
							beforeDelete={beforeDeleteReport}
						>
							<Button variant="text" size="large" color="error">
								Delete Report
							</Button>
						</DeletePopover>
					</MenuItem>
				</Menu>

			</Table.Cell>
		);
	}

	return (
		<Table.Cell
			{...props}
			onClick={handleNavigate}
		/>
	);
};


export default PatientReportsCell;
